<template>
    <li
        class="wb-breadcrumb-item"
    >
        <component :is="is"
                   :to="href"
                   :class="classes"
        >
            <WBText tag="span"
                    size="caption-1"
            >
                {{ title }}
            </WBText>
        </component>

        <WBIcon v-if="!isLast"
                class="wb-breadcrumb-item__icon"
                name="chevron-right"
        />
    </li>
</template>

<script setup lang="ts">
    import type { BreadcrumbItem } from '~/src/shared/components/ui/breadcrumb/types'

    const props = defineProps<BreadcrumbItem & {
        isLast: boolean
    }>()

    const is = computed(() => {
        if (props.href) {
            return defineNuxtLink({})
        }

        return 'div'
    })

    const classes = computed(() => ({
        'wb-breadcrumb-item__link': props.href,
        'wb-breadcrumb-item__element': !props.href,
    }))
</script>

<style scoped lang="scss">
    .wb-breadcrumb-item {
        position: relative;
        display: flex;
        align-items: center;
        flex-shrink: 0;

        &__link {
            position: relative;
            transition: color $default-transition;

            &:not(._inactive) {
                color: var(--indigo-400);

                @include hover {
                    color: var(--blue-600);
                }
            }

            &._inactive {
                color: var(--grey-700);
            }
        }

        &__icon {
            display: flex;
            align-items: center;
            width: 1.4rem;
            height: 1.4rem;
            margin: 0 1.2rem;
            color: var(--grey-500);
        }
    }
</style>
